import React, { useMemo, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";

export default function CourseEnrollPage() {
  const navigate = useNavigate();
  const { courseId } = useParams();

  const course = useMemo(() => {
    return {
      id: courseId || "course_mock_001",
      title: "AI Automation 101: เริ่มต้นสร้างระบบอัตโนมัติด้วย AI",
      priceText: "฿990",
    };
  }, [courseId]);

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    occupation: "",
    note: "",
    accept: false,
  });

  const [submitted, setSubmitted] = useState(false);

  const setField = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const onSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    // ✅ mock validation
    if (!form.fullName || !form.email || !form.accept) return;

    // ✅ mock success -> ไปหน้าเรียน
    navigate(`/learn/${course.id}`);
  };

  const invalid = submitted && (!form.fullName || !form.email || !form.accept);

  return (
    <div className="container py-4">
        {/* ✅ Header เต็มความกว้าง (แยกออกจาก row) */}
        <div className="mb-4">
        <Link to="/courses" className="text-decoration-none">
            ← กลับไปหน้าคอร์สทั้งหมด
        </Link>

        <h1 className="h4 mt-2 mb-1">สมัครเรียนคอร์ส</h1>
        <div className="text-secondary">{course.title}</div>
        </div>

        {/* ✅ Row ของฟอร์ม + สรุปรายการ เริ่มพร้อมกัน */}
        <div className="row g-4">
        <div className="col-lg-7">
            <div className="card">
            <div className="card-body">
                <form onSubmit={onSubmit}>
                <div className="mb-3">
                    <label className="form-label">ชื่อ-นามสกุล *</label>
                    <input
                    className={`form-control ${
                        submitted && !form.fullName ? "is-invalid" : ""
                    }`}
                    value={form.fullName}
                    onChange={(e) => setField("fullName", e.target.value)}
                    placeholder="กรอกชื่อ-นามสกุล"
                    />
                    <div className="invalid-feedback">กรุณากรอกชื่อ-นามสกุล</div>
                </div>

                <div className="mb-3">
                    <label className="form-label">อีเมล *</label>
                    <input
                    type="email"
                    className={`form-control ${
                        submitted && !form.email ? "is-invalid" : ""
                    }`}
                    value={form.email}
                    onChange={(e) => setField("email", e.target.value)}
                    placeholder="name@example.com"
                    />
                    <div className="invalid-feedback">กรุณากรอกอีเมล</div>
                </div>

                <div className="row g-3">
                    <div className="col-md-6">
                    <label className="form-label">เบอร์โทร</label>
                    <input
                        className="form-control"
                        value={form.phone}
                        onChange={(e) => setField("phone", e.target.value)}
                        placeholder="0xx-xxx-xxxx"
                    />
                    </div>
                    <div className="col-md-6">
                    <label className="form-label">อาชีพ/สถานะ</label>
                    <input
                        className="form-control"
                        value={form.occupation}
                        onChange={(e) => setField("occupation", e.target.value)}
                        placeholder="นักศึกษา / พนักงาน / เจ้าของกิจการ"
                    />
                    </div>
                </div>

                <div className="mt-3">
                    <label className="form-label">หมายเหตุ</label>
                    <textarea
                    className="form-control"
                    rows={3}
                    value={form.note}
                    onChange={(e) => setField("note", e.target.value)}
                    placeholder="อยากให้ทีมงานช่วยอะไรเพิ่มเติมไหม (optional)"
                    />
                </div>

                <div className="form-check mt-3">
                    <input
                    className={`form-check-input ${
                        submitted && !form.accept ? "is-invalid" : ""
                    }`}
                    type="checkbox"
                    id="accept"
                    checked={form.accept}
                    onChange={(e) => setField("accept", e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="accept">
                    ฉันยอมรับข้อกำหนดและนโยบายความเป็นส่วนตัว *
                    </label>
                    <div className="invalid-feedback">
                    กรุณาติ๊กยอมรับข้อกำหนดก่อนสมัครเรียน
                    </div>
                </div>

                {invalid && (
                    <div className="alert alert-warning mt-3 mb-0">
                    กรุณากรอกข้อมูลที่จำเป็นให้ครบ
                    </div>
                )}

                <div className="d-grid mt-3">
                    <button type="submit" className="btn btn-primary">
                    ยืนยันการสมัคร (mock)
                    </button>
                </div>

                <div className="text-secondary small mt-2">
                    * ตอนนี้เป็น mockup: ยังไม่บันทึกข้อมูล/ยังไม่เชื่อม payment
                </div>
                </form>
            </div>
            </div>
        </div>

        <div className="col-lg-5">
            <div className="card border">
            <div className="card-body">
                <div className="fw-semibold mb-2">สรุปรายการ</div>

                <div className="d-flex justify-content-between gap-3">
                <span className="text-secondary">คอร์ส</span>
                <span className="text-end">{course.title}</span>
                </div>

                <div className="d-flex justify-content-between mt-2">
                <span className="text-secondary">ราคา</span>
                <span className="fw-semibold">{course.priceText}</span>
                </div>

                <hr />

                <div className="text-secondary small">
                หลังยืนยัน (mock) ระบบจะพาไปหน้าเรียนทันที
                </div>
            </div>
            </div>

            <div className="alert alert-info mt-3 mb-0">
            ถ้าต้องการ mock flow “ชำระเงิน” เราสามารถเพิ่มหน้า PaymentMockPage ได้ครับ
            </div>
        </div>
        </div>
    </div>
    );

}
